import { addClass, hasClass, removeClass } from '../helpers/class_helper';
import { animate } from '../helpers/animations_helper';
import { outerSlideLeft, innerSlideLeft, outerSlideRight, innerSlideRight } from '../datas/_animations';
import Stepper from './stepper'


export default class Wizard extends Stepper {

/*-- Private methods ---------------------------------------------------------*/

  _showPanel(tabId) {
    const _this = this;

    const isInit = (_this.selected == null);
    let panelToShow    = null;
    let panelToHide    = this._panels[_this.selected];
    let innerAnimation = null;
    let outerAnimation = null;

    _this._panels.forEach( (panel, index) => {
      if (panel.getAttribute(_this._options.dataAttr) == tabId) {
        if (index < _this.selected) {
          innerAnimation = innerSlideRight;
          outerAnimation = outerSlideRight;
        } else {
          innerAnimation = innerSlideLeft;
          outerAnimation = outerSlideLeft;
        }
        panelToShow = panel;
        _this.selected = index;
      }
    });
    
    if (isInit) {
      addClass(panelToShow, _this._options.panelActiveClass);
    } else {
      animate(panelToShow, innerAnimation, {
        beginCallback: function() {
          addClass(panelToShow, _this._options.panelActiveClass);
        },
        completeCallback: function() {
          panelToShow.style.transform = 'translateX(0)';
        },
      });
      animate(panelToHide, outerAnimation, {
        beginCallback: function() {
          panelToHide.style.transform = 'translateX(0)';
        },
        completeCallback: function() {
          removeClass(panelToHide, _this._options.panelActiveClass);
        },
      });
    }
  }

  _bindTabs() {} //! important ! Don't delete

}



// WEBPACK FOOTER //
// ./assets/javascripts/libs/wizard.js